import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "column" }

import { ref } from 'vue';
import config from '@/config.json';


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

const version = ref(config.version);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, [
          _createElementVNode("small", null, [
            _cache[0] || (_cache[0] = _createStaticVNode("<a href=\"https://digital-vereint.de\" data-v-5503e7dd>digital verein(t)</a><span class=\"divider\" aria-hidden=\"true\" data-v-5503e7dd></span><a href=\"https://digital-vereint.de/impressum/\" target=\"_blank\" data-v-5503e7dd>Impressum</a><span class=\"divider\" aria-hidden=\"true\" data-v-5503e7dd></span><a href=\"https://digital-vereint.de/datenschutzerklaerung/\" target=\"_blank\" data-v-5503e7dd>Datenschutz</a><span class=\"divider\" aria-hidden=\"true\" data-v-5503e7dd></span>", 6)),
            _createTextVNode(" v " + _toDisplayString(version.value), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})